module.exports = __webpack_public_path__ + "assets/img/pingtaiyoushiCover1.c4294f29.jpg";